import React from "react";
import { Box, Button, Typography } from "@mui/material";
import Header from "../components/layout/Header";

function Dashboard() {
    return (
        <div>
            <Header />
            <Box sx={{ p: 3 }}>
                <Typography variant="h4" gutterBottom>
                    Dashboard
                </Typography>
                <Typography variant="body1">
                    Bienvenue sur votre tableau de bord ! Ici, vous pouvez gérer vos projets, créer vos modèles, suivre vos publications et accéder à toutes les fonctionnalités de l'application. 
                </Typography>

                <Button href="/model">Model</Button>
                <Button href="/design">Design</Button>
                <Button href="/users">Utilisateurs</Button>
            </Box>
            <Box sx={{ p: 3 }}>
                <Typography variant="h5" gutterBottom>
                    Publication en cours
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Vous n'avez pas de publication en cours. Commencez par créer un projet ou un modèle !
                </Typography>
            </Box>
            <Box sx={{ p: 3 }}>
                <Typography variant="h5" gutterBottom>
                    Actions rapides
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Utilisez les boutons ci-dessous pour créer rapidement un modèle ou un design.
                </Typography>
                <Button href="/model/new">Créer un modèle</Button>
                <Button href="/design/new">Créer un design</Button>
            </Box>
        </div>
    );
}

export default Dashboard;